"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedStyles = void 0;
const colors_1 = require("./constants/colors");
class SharedStyles {
    static get COLOR() {
        return colors_1.COLOR;
    }
}
exports.SharedStyles = SharedStyles;
